import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { PCCard } from '../../../components/Common';
import { ParameterMandatoryForm, ParameterOptionalForm } from '../../../components/Parameter';
import { searchView } from '../ParameterNewEdit/viewConfig';
import { ParameterStatusUtil } from '../../../api';
import { StatusForm } from '../../../components/Forms';

interface BasicParameterSearchProps {
}

type ParameterSearchProps = BasicParameterSearchProps;
/**
 * @author Jungwirth
 */
export const ParameterSearchForm: React.FC<ParameterSearchProps> = (): JSX.Element => {


  return (
    <PCCard
      id="search"
      footer={() => (
        <React.Fragment>
          <div className="float-right">
            <Button color="link" type="reset">
              <FormattedMessage id="button_search_reset" />
            </Button>{' '}
            <Button color="primary" type="submit">
              <FormattedMessage id="button_search" />
            </Button>{' '}
          </div>
        </React.Fragment>
      )}>
      <React.Fragment>
        <ParameterMandatoryForm
          viewConfig={searchView} />
        <ParameterOptionalForm
          viewConfig={searchView} />
        <StatusForm
          name="status"
          label="status"
          viewConfig={searchView}
          statusUtil={ParameterStatusUtil}
        />
      </React.Fragment>
    </PCCard>
  );
}
